import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class PreparationResourceTypeData extends EntityData<PreparationResourceTypeData> {
    @identifier id: number;
    @field name: string;
    @field preparationTime: number;
}

export class PreparationResourceTypeReferenceData extends EntityData<PreparationResourceTypeReferenceData> {
    @identifier id: number;
    @field name: string;
}
